<template>
  <div class="olt">
    <h1>Olt, Alt</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/olt_1kl.jpg" width="125" height="110" border="0" alt="Kloster am Olt / Alt" 
        @click="callImageClick('Kloster am Olt / Alt', 'olt_1.jpg', $event)">
        <br>Kloster am Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_2kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_2.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_3kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_3.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_4kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_4.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_5kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_5.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_6kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_6.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_7kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_7.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_8kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_8.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_9kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_9.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_10kl.jpg" width="125" height="110" border="0" alt="Olt / Alt" 
        @click="callImageClick('Olt / Alt', 'olt_10.jpg', $event)">
        <br>Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/olte_1kl.jpg" width="125" height="110" border="0" alt="Oltenia" 
        @click="callImageClick('Oltenia', 'olte_1.jpg', $event)">
        <br>Oltenia
      </div>
      <div class="foto">
        <img src="../assets/fotos/ramn_1kl.jpg" width="125" height="110" border="0" alt="Râmnicu Vâlcea" 
        @click="callImageClick('Râmnicu Vâlcea', 'ramn_1.jpg', $event)">
        <br>Râmnicu Vâlcea
      </div>
      <div class="foto">
        <img src="../assets/fotos/ramn_2kl.jpg" width="125" height="110" border="0" alt="Râmnicu Vâlcea" 
        @click="callImageClick('Râmnicu Vâlcea', 'ramn_2.jpg', $event)">
        <br>Râmnicu Vâlcea
      </div>
      <div class="foto">
        <img src="../assets/fotos/ramn_3kl.jpg" width="125" height="110" border="0" alt="Râmnicu Vâlcea" 
        @click="callImageClick('Râmnicu Vâlcea', 'ramn_3.jpg', $event)">
        <br>Râmnicu Vâlcea
      </div>
      <div class="foto">
        <img src="../assets/fotos/ramn_4kl.jpg" width="125" height="110" border="0" alt="Râmnicu Vâlcea" 
        @click="callImageClick('Râmnicu Vâlcea', 'ramn_4.jpg', $event)">
        <br>Râmnicu Vâlcea
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>